// openEHR RM model — BMM package org.openehr.rm.common.directory
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import type { T } from "../_shared.ts";
import type { ITEM_STRUCTURE } from "../data_structures/item_structure.ts";
import { LOCATABLE } from "./archetyped.ts";
import { VERSIONED_OBJECT } from "./change_control.ts";
import { applyRmInit, type RmInit } from "../../base/apply_rm_init.ts";

/**
 * A version-controlled hierarchy of \`FOLDERs\` giving the effect of a directory.
 */
export class VERSIONED_FOLDER extends VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

}

/**
 * The concept of a named folder.
 *
 * NOTE: It is strongly recommended that the inherited attribute \`_uid_\` be populated in _top-level_ (i.e. tree-root) \`FOLDER\` objects, using the UID copied from the \`_object_id()_\` of the \`_uid_\` field of the enclosing \`VERSION\` object. +
 * For example, the \`ORIGINAL_VERSION.uid\` \`87284370-2D4B-4e3d-A3F3-F303D2F4F34B::uk.nhs.ehr1::2\`  would be copied to the \`_uid_\` field of the top \`FOLDER\` object.
 */
export class FOLDER extends LOCATABLE {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

  /**
   * The list of references to other (usually) versioned objects logically in this folder.
   */
  items?: undefined;
  /**
   * Sub-folders of this \`FOLDER\`.
   */
  folders?: undefined;
  /**
   * Archetypable meta-data for \`FOLDER\`.
   */
  details?: ITEM_STRUCTURE;
}
